import makeSettingsReducer from 'app/common/reducers/settings/makeSettingsReducer'

const reportSalesDefaultState = {
  splitByDays: false,
}

export default makeSettingsReducer('reportSales', reportSalesDefaultState)
